<tc-pickup-dropoff-details
        [dropOffs]="dropOffs"
        [pickUps]="pickUps"
        [selectedIndex]="selectedIndex"
        (closePopUp)="onClosePopup($event)"
>

</tc-pickup-dropoff-details>
